export default "__VITE_ASSET__BKN8sHUl__"